
<template>
  <el-popover
      placement="right"
      width="400"
      trigger="hover">
    <user-info :id="id"></user-info>
    <div class="info" slot="reference">
      <div>
        <el-image
            style="width: 80px; height: 80px; border-radius: 50%"
            :src="info.avatar">
        </el-image>
      </div>
      <div>{{info.nickname}}</div>
    </div>
  </el-popover>

</template>

<style scoped>
  .info{
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    justify-content: center;
  }
</style>

<script>
import { getAccountInfo } from '@/api/demo/user'
import UserInfo from '@/components/users/userInfo.vue'

export default {
  name: 'popoverUserInfo',
  components: { UserInfo },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      info: {}
    }
  },
  watch: {
    id: function (newVal, oldVal) {
      this.getUserInfo()
    }
  },
  mounted () {
    this.getUserInfo()
  },
  methods: {
    getUserInfo () {
      console.log('this.id', this.id)
      getAccountInfo(this.id).then(res => {
        this.info = res
      })
    }
  }
}

</script>
